import type { PaymentRead } from "@/api-v3";

/**
 * The amount a participant sees for a payment. PASS sets the Approved Amount
 * only once a payment is approved, and it can sit below the Claimed Amount
 * after an Amount Adjustment. Until then the payment shows its `amount`.
 */
export const getPaymentDisplayAmount = (
  payment: Pick<PaymentRead, "amount" | "approved_amount">
): string => payment.approved_amount ?? payment.amount;
